import React from "react";
import LegalDocs from "../Components/LegalDocs";
import Footer from "../Components/Footer";

function Legal() {
  return (
    <>
      <LegalDocs />
      <Footer />
    </>
  );
}

export default Legal;
